import React from 'react';
import moment from 'moment';
import { IconLoader } from 'common/IconLoader';
import get from 'lodash/get';
import { isGa2Device } from './deviceTwinUtils';
import icon_alarm_critical from 'imgs/icons/windows/icon_alarm_critical.svg';
import icon_alarm_major from 'imgs/icons/windows/icon_alarm_major.svg';
import icon_alarm_minor from 'imgs/icons/windows/icon_alarm_minor.svg';
import icon_alarm_warning from 'imgs/icons/windows/icon_alarm_warning.svg';
import icon_alarm_info from 'imgs/icons/windows/icon_alarm0.svg';
import icon_alarm_noalarm from 'imgs/icons/windows/icon_alarm_noalarm.svg';
//pivot icons
import icon_alarm_critical_pivot from 'imgs/icons/windows/icon_alarm_critical_pivot.svg';
import icon_alarm_major_pivot from 'imgs/icons/windows/icon_alarm_major_pivot.svg';
import icon_alarm_minor_pivot from 'imgs/icons/windows/icon_alarm_minor_pivot.svg';
import icon_alarm_warning_pivot from 'imgs/icons/windows/icon_alarm_warning_pivot.svg';
import icon_alarm_info_pivot from 'imgs/icons/windows/icon_alarm_info_pivot.svg';
import icon_alarm_noalarm_pivot from 'imgs/icons/windows/icon_alarm_noalarm_pivot.svg';
//echo icons
import icon_alarm_critical_echo from 'imgs/icons/windows/icon_alarm_critical_echo.svg';
import icon_alarm_major_echo from 'imgs/icons/windows/icon_alarm_major_echo.svg';
import icon_alarm_minor_echo from 'imgs/icons/windows/icon_alarm_minor_echo.svg';
import icon_alarm_warning_echo from 'imgs/icons/windows/icon_alarm_warning_echo.svg';
import icon_alarm_info_echo from 'imgs/icons/windows/icon_alarm_info_echo.svg';
import icon_alarm_noalarm_echo from 'imgs/icons/windows/icon_alarm_noalarm_echo.svg';
import {
  Alarms,
  paramLabelValueList,
  paramLabelValues,
  timeZoneAbbrToFull,
  SPECIAL_CHARS_FORMAT,
  deviceDisplayTypes,
  defaultPeriodicSwCheckConfig,
  schedTypes,
  dayPrefixes,
  DEFAULT_ECHO_TAB_COLUMNS,
  DEFAULT_PIVOT_TAB_COLUMNS,
  DEFAULT_ALL_DEVICES_TAB_COLUMNS,
  USER_PREFERENCE_SETS,
  emailRegex,
  ERROR_CODES,
  AzelRange,
  AzElRangeGA2
} from 'common/utils/constants';

const htmlparser2 = require('htmlparser2');

export const getMaxAlarmFromDevice = (device) => {
  try {
    let alarmLevels = Object.keys(device.tags['fm-alarms']);

    let mostCriticalAlarmVal = -9999;
    let mostCriticalAlarm = null;

    alarmLevels.forEach((a) => {
      let normAlarm = a.toUpperCase();

      if (device.tags['fm-alarms'][a] === true && Alarms[normAlarm] > mostCriticalAlarmVal) {
        mostCriticalAlarmVal = Alarms[normAlarm];
        mostCriticalAlarm = normAlarm;
      }
    });

    return mostCriticalAlarm;
  } catch (e) {
    return null;
  }
};

export const getMaxAlarmForDevices = (devices) => {
  //alarms are already sorted in terms of severity
  let maxAlarm = 'CLEARED';
  devices.forEach((device) => {
    let alarmString = getMaxAlarmFromDevice(device);
    if (Alarms[alarmString] != null && Alarms[alarmString] > Alarms[maxAlarm]) {
      maxAlarm = alarmString.toUpperCase();
    }
  });
  return maxAlarm;
};

//Given an array of objects sort by metricList array where each element is in priority order
export function nSort(arr, metricList) {
  return arr.sort((a, b) => {
    for (let i = 0; i < metricList.length; i++) {
      let item1 = metricList[i].order === 'a' ? a[metricList[i].metric] : b[metricList[i].metric];
      let item2 = metricList[i].order === 'a' ? b[metricList[i].metric] : a[metricList[i].metric];

      if (typeof item1 === 'string' && typeof item2 === 'string') {
        if (Date.parse(item1) && Date.parse(item2)) {
          let date1 = Date.parse(item1);
          let date2 = Date.parse(item2);

          if (date1 - date2 !== 0) {
            return date1 - date2;
          }
        }

        if (Alarms[item1] != null && Alarms[item2] != null && Alarms[item1] !== Alarms[item2]) {
          return Alarms[item1] - Alarms[item2];
        }

        if (item1 !== item2) return ('' + item1).localeCompare(item2);
      }

      if (typeof item1 === 'number' && typeof item2 === 'number') {
        return item1 - item2;
      }
    }

    return 0;
  });
}

export function arrayWithIDToDictionary(data) {
  let dataDictionary = {};
  data.forEach((d) => (dataDictionary[d.id] = d));
  return dataDictionary;
}

export function getFilteredKpiData(counters) {
  let uniqueCounters = counters.filter(
    (counter, index, self) => self.findIndex((c) => c.name === counter.name) === index
  );

  let firstActive = false;

  let filteredKpiData = uniqueCounters.reduce((filteredArray, counter) => {
    if (
      (counter.type === 'Long' || counter.type === 'Double' || counter.type === 'Integer') &&
      counter.name.charAt(0) !== '[' &&
      counter.name.toLowerCase() !== 'activebeam' &&
      counter.name.toLowerCase() !== 'events_time_since_boot' &&
      counter.name !== 'sysUptime' &&
      counter.name !== 'systemUpTime'
    ) {
      let activeVal = firstActive === false;

      let kpiData = {
        label: counter?.['_metadata']?.uiFriendlyName ?? counter.name,
        value: counter.name,
        active: activeVal
      };
      if (counter['_metadata']) {
        kpiData.metadata = counter['_metadata'];
      }
      filteredArray.push(kpiData);

      firstActive = true;
    }
    return filteredArray;
  }, []);

  return filteredKpiData;
}

// get filtered data from cm counters
export function getFilteredParamData(counters) {
  if (!counters) return [];

  let uniqueCounters = counters.filter(
    (counter, index, self) => self.findIndex((c) => c.name === counter.name) === index
  );

  let filteredParamData = [];
  paramLabelValueList.forEach((value) => {
    const candidateCounter = uniqueCounters.find((counter) => counter.name === value);
    if (candidateCounter) {
      filteredParamData.push({
        label: paramLabelValues[candidateCounter.name],
        value: candidateCounter.name,
        active: false
      });
    }
  });

  return filteredParamData;
}

export function alarmSeverityToIcon(alarm) {
  switch (Alarms[alarm]) {
    case Alarms.INDETERMINATE:
    case Alarms.UNDEFINED_SEVERITY: {
      return IconLoader.icon_alarm_undefined;
    }
    case Alarms.CRITICAL: {
      return IconLoader.icon_alarm_critical;
    }
    case Alarms.MAJOR: {
      return IconLoader.icon_alarm_major;
    }
    case Alarms.MINOR: {
      return IconLoader.icon_alarm_minor;
    }
    case Alarms.WARNING: {
      return IconLoader.icon_alarm_warning;
    }
    case Alarms.INFO: {
      return IconLoader.icon_alarm_info;
    }
    default: {
      // return icon_alarm_noalarm;
      return null;
    }
  }
}

export function alarmSeverityToIconWithProductType(alarmName, productType = 'subscriber') {
  let distilledProductType = distillProductType(productType);

  if (alarmName == null) {
    if (distilledProductType === 'donor' || distilledProductType === 'service') return icon_alarm_noalarm_pivot;
    if (distilledProductType === 'subscriber') return icon_alarm_noalarm_echo;
  }

  let alarmLevel = Alarms[alarmName];

  if (distilledProductType === 'donor' || distilledProductType === 'service' || distilledProductType === 'Pivotal 5G') {
    switch (alarmLevel) {
      case Alarms.CRITICAL: {
        return icon_alarm_critical_pivot;
      }
      case Alarms.MAJOR: {
        return icon_alarm_major_pivot;
      }
      case Alarms.MINOR: {
        return icon_alarm_minor_pivot;
      }
      case Alarms.WARNING: {
        return icon_alarm_warning_pivot;
      }
      case Alarms.INFO: {
        return icon_alarm_info_pivot;
      }
      default: {
        return icon_alarm_noalarm_pivot;
      }
    }
  } else if (distilledProductType === 'subscriber') {
    switch (alarmLevel) {
      case Alarms.CRITICAL: {
        return icon_alarm_critical_echo;
      }
      case Alarms.MAJOR: {
        return icon_alarm_major_echo;
      }
      case Alarms.MINOR: {
        return icon_alarm_minor_echo;
      }
      case Alarms.WARNING: {
        return icon_alarm_warning_echo;
      }
      case Alarms.INFO: {
        return icon_alarm_info_echo;
      }
      default: {
        return icon_alarm_noalarm_echo;
      }
    }
  } else {
    switch (alarmLevel) {
      case Alarms.CRITICAL: {
        return icon_alarm_critical;
      }
      case Alarms.MAJOR: {
        return icon_alarm_major;
      }
      case Alarms.MINOR: {
        return icon_alarm_minor;
      }
      case Alarms.WARNING: {
        return icon_alarm_warning;
      }
      case Alarms.INFO: {
        return icon_alarm_info;
      }
      default: {
        return icon_alarm_noalarm;
      }
    }
  }
}

//crazy
export function mixedDeviceIdArrayToDeviceIdArray(mixedIdArray, mixedDevicesDataDictionary) {
  let flattenedIdArray = [];
  mixedIdArray.forEach((id) => {
    if (mixedDevicesDataDictionary[id]?.members) {
      mixedDevicesDataDictionary[id].members.forEach((m) => {
        flattenedIdArray.push(m.id);
      });
    } else flattenedIdArray.push(id);
  });

  return flattenedIdArray;
}

export function bundleIdsToDeviceIds(ids, bundlesDictionary) {
  let resultDeviceIds = [];

  ids.forEach((id) => {
    if (bundlesDictionary[id] != null) {
      for (let member of bundlesDictionary[id].members) {
        resultDeviceIds.push(member.deviceId);
      }
    } else resultDeviceIds.push(id);
  });

  return resultDeviceIds;
}

export function getDonorUnitFromBundleMembers(members = []) {
  let donorUnit = null;
  for (let member of members) {
    if (distillProductType(member?.properties?.reported?.productType) === 'donor') {
      donorUnit = member;
      break;
    }
  }
  return donorUnit;
}

export function getMainUnitFromBundleMembers(members) {
  let targetDevice = getDonorUnitFromBundleMembers(members);

  if (targetDevice == null) {
    targetDevice = members.find((d) => d?.properties?.reported?.location != null);
  }

  if (targetDevice == null) {
    targetDevice = members[0];
  }

  return targetDevice;
}

export function getDeviceIndexByID(id, devices) {
  if (devices != null)
    for (let i = 0; i < devices.length; i++) {
      if (devices[i].id === id) {
        return i;
      }
    }
  return -1;
}

export function getDeviceByID(id, devices) {
  for (let i = 0; i < devices.length; i++) {
    if (devices[i].id === id) {
      return devices[i];
    }
  }
  return null;
}

/**
 * Send the response if success, throw an error if no success from response
 *
 * @method _checkStatus
 * @param {object} res the JSON object resulting from the Cloud information fetching
 * @return the ok status or display the error
 *
 */
export const checkStatus = (res) => {
  if (res.ok === true && res.status >= 200 && res.status < 300) {
    return res;
  } else {
    console.log('Error, result:', res);
    throw new Error(res.status);
  }
};

export function getActiveSwFromSWLoad(softwareLoad) {
  if (!softwareLoad) return '';

  for (let key of Object.keys(softwareLoad)) {
    if (softwareLoad[key]?.bootStatus && softwareLoad[key]?.bootStatus.toLowerCase() === 'active') {
      return softwareLoad[key].systemSWVer;
    }
  }

  return '';
}

export function getDeviceSwVersion(device, swLoad = null) {
  if (isGa2Device(device)) {
    return get(device, 'properties.reported.DU.swdl-releases.active-release.sys-sw-rel', 'Unknown');
  }
  let sw_version_str = '';
  try {
    let softwareLoad = null;

    if (swLoad != null) {
      softwareLoad = swLoad;
    } else if (device.properties?.reported?.softwareLoad) softwareLoad = device.properties.reported.softwareLoad;

    if (softwareLoad == null) {
      throw new Error('no softwareLoad');
    }
    if (softwareLoad['0'] == null) {
      throw new Error('no softwareLoad[0]');
    }
    if (softwareLoad['0'].bootStatus == null) {
      throw new Error('no bootStatus');
    }

    if (softwareLoad['0'].bootStatus.toLowerCase() === 'active') {
      if (softwareLoad['0'].systemSWVer != null) {
        sw_version_str = softwareLoad['0'].systemSWVer;
      } else {
        sw_version_str = softwareLoad['0'].systemSWVersion;
      }
    } else if (
      softwareLoad['1'] != null &&
      softwareLoad['1'].bootStatus != null &&
      softwareLoad['1'].bootStatus.toLowerCase() === 'active'
    ) {
      if (softwareLoad['1'].systemSWVer != null) {
        sw_version_str = softwareLoad['1'].systemSWVer;
      } else {
        sw_version_str = softwareLoad['1'].systemSWVersion;
      }
    } else {
      throw new Error('neither partition shows active boot status');
    }

    if (!sw_version_str) {
      throw new Error('empty software version');
    }
  } catch (error) {
    sw_version_str = 'Unknown';
  }

  return sw_version_str;
}

export function getInactiveAndActiveSwVersions(device = {}) {
  const swVersions = {
    inactive: 'Unknown',
    active: 'Unknown'
  };

  const swdlReleases = device?.properties?.reported?.DU?.['swdl-releases'];
  const softwareLoad = device?.properties?.reported?.softwareLoad;

  if (swdlReleases) {
    swVersions.inactive = swdlReleases?.['inactive-release']?.['sys-sw-rel'] || 'Unknown';
    swVersions.active = swdlReleases?.['active-release']?.['sys-sw-rel'] || 'Unknown';
  } else if (softwareLoad) {
    for (let i = 0; i < 2; i++) {
      const bootStatus = softwareLoad?.[i]?.bootStatus?.toLowerCase();
      const systemSWVer = softwareLoad?.[i]?.systemSWVer || 'Unknown';
      swVersions[bootStatus === 'inactive' ? 'inactive' : 'active'] = systemSWVer;
    }
  }

  return swVersions;
}

export function getLowestSwVersion(bundleDevice) {
  let bundleMembers = bundleDevice.members;
  let mainDevice = getDonorUnitFromBundleMembers(bundleMembers);
  let lowestSwVersion = getDeviceSwVersion(mainDevice);

  bundleMembers &&
    bundleMembers.forEach((member) => {
      let curVersion = getDeviceSwVersion(member);
      if (curVersion.toLowerCase() !== 'unknown' && lowestSwVersion > curVersion) lowestSwVersion = curVersion;
    });

  return lowestSwVersion;
}

/**
 *
 * @param {String} version the response sw_version string from Get Available SW versions API
 * @return {object} contains sw_version and tag_version strings
 */
export const getSwVersionAndTagVersion = (version) => {
  let swVersion = {
    sw_version: '',
    tag_version: ''
  };

  if (version === undefined || version == null || version === '') return swVersion;

  const splitIndex = version.indexOf('-');
  // no tag version
  if (splitIndex === -1) {
    swVersion.sw_version = version;
    return swVersion;
  }

  swVersion.sw_version = version.substring(0, splitIndex);
  swVersion.tag_version = version.substring(splitIndex + 1);
  return swVersion;
};

export function getNumericTrimmedSwVersion(device) {
  try {
    let version = getDeviceSwVersion(device);
    let version_numbers = version.split('.').map((str) => parseInt(str));
    if (version_numbers.length < 3) {
      throw new Error('sw version length less than 3');
    }

    let result = '' + version_numbers[0] + '.' + version_numbers[1] + '.' + version_numbers[2];

    return result;
  } catch (error) {
    console.log('getNumericTrimmedSwVersion error:', error);
    return null;
  }
}

export function getNumericArraySwVersion(version) {
  try {
    let version_numbers = version.split('.').map((str) => parseInt(str));
    if (version_numbers.length < 3) {
      throw new Error('sw version length less than 3');
    }
    return [version_numbers[0], version_numbers[1], version_numbers[2]];
  } catch (error) {
    return [0, 0, 0];
  }
}

export function swVersionCompare(v1, v2) {
  try {
    if (v1[0] - v2[0] !== 0) {
      return v1[0] - v2[0];
    } else if (v1[1] - v2[1] !== 0) {
      return v1[1] - v2[1];
    } else {
      return v1[2] - v2[2];
    }
  } catch (error) {
    console.log('bad version comparison, error:', error);
    return 0;
  }
}

export function distillProductType(productType) {
  let normalizedString = null;

  if (productType != null) normalizedString = productType.toUpperCase();

  switch (normalizedString) {
    case 'HBF_SERVICE':
    case 'HORN_WIDE_SERVICE':
    case 'HORN_NARROW_SERVICE':
    case 'SERVICE':
      return 'service';

    case 'HBF_DONOR':
    case 'DONOR':
    case 'GA2-N257':
    case 'GA2-N258':
    case 'GA2-N260':
      return 'donor';

    default:
      return 'subscriber';
  }
}

export function isPivot(deviceOrBundle) {
  if (deviceOrBundle.type === 'Pivot 5G') {
    return true;
  }

  const distilledType = distillProductType(deviceOrBundle.properties?.reported?.productType);

  return ['donor', 'service'].includes(distilledType);
}

export function hasHBF(device) {
  let productType = device?.properties?.reported?.productType;

  let normalizedString = null;

  if (productType != null) normalizedString = productType.toUpperCase();

  switch (normalizedString) {
    case 'ECHO':
    case 'SUBSCRIBER':
    case 'ES3_28':
    case 'ES4_39':
    case 'HBF_SERVICE':
    case 'HBF_DONOR':
    case 'DONOR':
      return true;
    case 'HORN_WIDE_SERVICE':
    case 'HORN_NARROW_SERVICE':
    case 'SERVICE':
      return false;
    default:
      return true;
  }
}

export function deviceToProductTypeDisplayString(device, forSwUpdate = false) {
  let productType = device?.properties?.reported?.productType;

  // when device parameter is a bundle object
  if (!productType && device?.type) {
    return device.type;
  }

  if (productType != null) {
    let displayString = forSwUpdate
      ? productTypeStringToDisplayStringForSwUpdate(productType)
      : productTypeStringToDisplayString(productType);

    if (displayString) return displayString;
  }

  return swVersionCompare(getNumericArraySwVersion(getDeviceSwVersion(device)), [1, 2, 0]) < 0 ? 'Echo 5G' : 'Unknown';
}

export function productTypeStringToDisplayString(productType) {
  let normalizedString = null;

  if (productType != null) normalizedString = productType.toUpperCase();

  switch (normalizedString) {
    case 'ECHO':
    case 'SUBSCRIBER':
    case 'ES3_28':
    case 'ES4_39':
      return 'Echo 5G';
    case 'HBF_DONOR':
    case 'DONOR':
      return 'Pivot 5G Donor';
    case 'HBF_SERVICE':
    case 'HORN_WIDE_SERVICE':
    case 'HORN_NARROW_SERVICE':
    case 'SERVICE':
      return 'Pivot 5G Service';
    case 'ESX_M6':
      return 'ESX_M6';
    case 'GA2-N257':
      return 'GA2-N257';
    case 'GA2-N258':
      return 'GA2-N258';
    case 'GA2-N260':
      return 'GA2-N260';
    default:
      return productType;
  }
}

export function productTypeStringToDisplayStringForSwUpdate(productType) {
  let normalizedString = null;

  if (productType != null) normalizedString = productType.toUpperCase();

  switch (normalizedString) {
    case 'SUBSCRIBER':
      return 'Subscriber';
    case 'ES3_28':
      return 'ES3_28';
    case 'ES4_39':
      return 'ES4_39';
    case 'ECHO':
      return 'Echo 5G';
    case 'HBF_DONOR':
    case 'DONOR':
      return 'Pivot 5G Donor';
    case 'HBF_SERVICE':
    case 'HORN_WIDE_SERVICE':
    case 'HORN_NARROW_SERVICE':
    case 'SERVICE':
      return 'Pivot 5G Service';
    case 'ESX_M6':
      return 'ESX_M6';
    case 'ESX_M5':
      return 'ESX_M5';
    case 'GA2-N257':
      return 'GA2-N257';
    case 'GA2-N258':
      return 'GA2-N258';
    case 'GA2-N260':
      return 'GA2-N260';
    default:
      return productType;
  }
}

export function getServiceUnits(members) {
  let serviceDevices = [];

  members.forEach((m) => {
    if (
      !(
        m.properties &&
        m.properties.reported &&
        m.properties.reported.productType &&
        distillProductType(m.properties.reported.productType) === 'donor'
      )
    ) {
      serviceDevices.push(m);
    }
  });

  return serviceDevices;
}

export function isObjectsEqual(obj1, obj2) {
  if (!obj1 && !obj2) return true;
  if (!obj1 || !obj2) return false;

  let keysArray1 = Object.keys(obj1);
  let keysArray2 = Object.keys(obj2);

  let keysLength1 = keysArray1.length;
  let keysLength2 = keysArray2.length;

  if (keysLength1 !== keysLength2) return false;

  for (let i = 0; i < keysLength1; i++) {
    if (obj1[keysArray1[i]] !== obj2[keysArray2[i]]) {
      return false;
    }
  }

  return true;
}

export function isArraysEqual(arr1, arr2, ignoreOrder = false) {
  if (arr1 === arr2) return true;
  if (arr1 == null || arr2 == null) return false;
  if (arr1.length !== arr2.length) return false;

  if (ignoreOrder) {
    arr1 = arr1.sort((a, b) => a - b);
    arr2 = arr2.sort((a, b) => a - b);
  }

  for (let i = 0; i < arr2.length; ++i) {
    if (arr1[i] !== arr2[i]) return false;
  }

  return true;
}

export function getNthKeyValue(object, targetindex) {
  let value = null;

  Object.keys(object).forEach((key, keyIndex) => {
    if (targetindex === keyIndex) {
      value = object[key];
    }
  });
  return value;
}

export function updateNthKeyValue(object, targetindex, value) {
  Object.keys(object).forEach((key, keyIndex) => {
    if (targetindex === keyIndex) {
      object[key] = value;
    }
  });

  return object;
}

export function getPermissionsFromRolePermissions(rolePermissions) {
  let permissionsList = [];

  if (rolePermissions)
    rolePermissions.forEach((role) => {
      let permissions = Object.keys(role.permissions);
      for (let i = 0; i < permissions.length; i++) {
        if (role && role.permissions && role.permissions[permissions[i]]) {
          role.permissions[permissions[i]].forEach((p) => {
            permissionsList.push(p);
          });
        }
      }
    });

  return permissionsList;
}

export function reactTableSortOnClick(parent, id) {
  if (
    parent.state.sorted &&
    parent.state.sorted.length > 0 &&
    parent.state.sorted[0].id === id &&
    parent.state.sorted[0].desc === false
  ) {
    parent.setState({
      sorted: [
        {
          id: id,
          desc: true
        }
      ]
    });
  } else {
    parent.setState({
      sorted: [
        {
          id: id,
          desc: false
        }
      ]
    });
  }
}

export function reactTableSortOnClickInFuncComp(sorted, setSorted, id) {
  if (sorted && sorted.length > 0 && sorted[0].id === id && sorted[0].desc === false) {
    setSorted([
      {
        id: id,
        desc: true
      }
    ]);
  } else {
    setSorted([
      {
        id: id,
        desc: false
      }
    ]);
  }
}

export function capitalizeFirstLetter(text) {
  let lowerCaseText = text.toLowerCase();
  return lowerCaseText.charAt(0).toUpperCase() + lowerCaseText.slice(1);
}

export function getLocalTimeZone() {
  let timeZoneGuess = moment.tz.guess();
  let time = new Date();
  let timeZoneOffset = time.getTimezoneOffset();
  let timeZoneAbbr = moment.tz.zone(timeZoneGuess).abbr(timeZoneOffset);
  let timeZoneFull = timeZoneAbbrToFull[timeZoneAbbr];

  return {
    full: timeZoneFull,
    abbr: timeZoneAbbr
  };
}

export const getTimeZone = () => moment().format('Z');

/*Checks a strings for html tags to prevent html/script injections*/
export function checkStringForHTML(inputString) {
  let hasTag = false;

  const parser = new htmlparser2.Parser(
    {
      onopentag() {
        hasTag = true;
      },
      ontext(text) {},
      onclosetag() {
        hasTag = true;
      }
    },
    { decodeEntities: true }
  );

  parser.write(inputString);
  parser.end();

  return hasTag;
}

export function getRelativeFilepath(fileString) {
  if (fileString == null) return null;

  let targetIndex = fileString.lastIndexOf('/');

  if (targetIndex === -1) return null;

  return fileString.substring(targetIndex + 1);
}

export function checkIsCommissioned(device, isBundle) {
  const DEFAULT_AZ_VALUE = 361;
  const DEFAULT_EL_VALUE = 361;

  const bundleDevices = isBundle ? device.members : [device];

  //new way to check commissioning is by checking for the "commissioned" flag

  if (bundleDevices[0]?.tags?.bundle?.commissioned) {
    let isCommissioned = true;

    for (let currDevice of bundleDevices) {
      if (currDevice?.tags?.bundle?.commissioned == null || currDevice.tags.bundle.commissioned === false) {
        isCommissioned = false;
      }
    }

    return isCommissioned;
  }

  //old way
  for (let currDevice of bundleDevices) {
    const currentAntennaDirection = currDevice?.properties?.reported['antenna_direction'];

    // commissioned if any device does not have either default azimuth or elevation values
    if (
      currentAntennaDirection &&
      (currentAntennaDirection.beamAzimuth !== DEFAULT_AZ_VALUE ||
        currentAntennaDirection.beamElevation !== DEFAULT_EL_VALUE)
    ) {
      return true;
    }
  }

  // not commissioned if devices Az and El are all default value
  return false;
}

export const isObjectEmpty = (obj) => {
  if (!obj) return true;

  return Object.keys(obj).length === 0;
};

export function createDevice(input) {
  let location;
  if (input && input.properties && input.properties.reported.location) {
    location = { lat: input.properties.reported.location.lat, lon: input.properties.reported.location.long };
  } else {
    /* Make fake location data*/
    //location = hashFnv32a(input.deviceId);
    location = { lat: 0, lon: 0 };
  }

  let min_az = -76;
  let max_az = 76;
  let step_az = 2;
  let min_el = -35;
  let max_el = 35;
  let step_el = 5;

  let updateProgress =
    input && input.properties && input.properties.reported.updateProgress
      ? input.properties.reported.updateProgress
      : 0;
  let softwareUpdating =
    input && input.properties && input.properties.reported.softwareUpdating != null
      ? input.properties.reported.softwareUpdating
      : false;

  return {
    id: input.deviceId,
    name: input.deviceId.slice(0, 4) + input.deviceId.slice(-4),
    type: input.deviceId.slice(0, 4),
    location: location,
    softwareUpdating: softwareUpdating,
    updateProgress: updateProgress,
    alarms: [], //alarms: Math.random() > 0.5 ? alarms : (Math.random() > 0.5 ? [alarms[1]] : (Math.random() > 0.5 ? [alarms[2]] : [])),
    parameters: input && input.properties && input.properties.reported ? input.properties.reported : null,
    rasterInfo: { min_az: min_az, max_az: max_az, step_az: step_az, min_el: min_el, max_el: max_el, step_el: step_el },
    ...input
  };
}

export const groupNameInputValidator = (groupName = '') => {
  if (!groupName) {
    return 'The name input cannot be empty.';
  } else if (groupName.length > 50) {
    return 'List name should NOT be longerthan 50 characters.';
  } else if (SPECIAL_CHARS_FORMAT.test(groupName)) {
    return 'List name should NOT contain any special characters.';
  } else {
    return null;
  }
};

export const trimAndReplaceSpaces = (string) => {
  if (string) {
    return string.trim().replace(/\s\s+/g, ' ');
  }
  return string;
};

export const getNormalizedKpiId = (kpi) => {
  let kpiTranslations = {
    systemTemp: 'systemTemp',
    sysUpTime: 'sysUpTime',
    deviceTwin_reported_antenna_direction_beamAzimuth: 'deviceTwin.reported.antenna.direction.beamAzimuth',
    deviceTwin_reported_antenna_direction_beamElevation: 'deviceTwin.reported.antenna.direction.beamElevation',
    deviceTwin_reported_VDL_Gain_value: 'deviceTwin.reported.VDL.Gain.value',
    deviceTwin_reported_HDL_Gain_value: 'deviceTwin.reported.HDL.Gain.value',
    deviceTwin_reported_VUL_Gain_value: 'deviceTwin.reported.VUL.Gain.value',
    deviceTwin_reported_HUL_Gain_value: 'deviceTwin.reported.HUL.Gain.value',
    PanelPower_HPolDL: 'PanelPower.HPolDL',
    PanelPower_HPolUL: 'PanelPower.HPolUL',
    PanelPower_VPolDL: 'PanelPower.VPolDL',
    PanelPower_VPolUL: 'PanelPower.VPolUL',
    gain_relax_count_dh: 'gain.relax.count.dh',
    gain_relax_count_dv: 'gain.relax.count.dv',
    gain_relax_count_uh: 'gain.relax.count.uh',
    gain_relax_count_uv: 'gain.relax.count.uv',
    gain_backoff_count_dh: 'gain.backoff.count.dh',
    gain_backoff_count_dv: 'gain.backoff.count.dv',
    gain_backoff_count_uh: 'gain.backoff.count.uh',
    gain_backoff_count_uv: 'gain.backoff.count.uv',
    gain_osc_backoff_count_h: 'gain.osc.backoff.count.h',
    gain_osc_backoff_count_v: 'gain.osc.backoff.count.v',
    gain_osc_gain_dh: 'gain.osc.gain.dh',
    gain_osc_gain_dv: 'gain.osc.gain.dv',
    gain_osc_gain_uh: 'gain.osc.gain.uh',
    gain_osc_gain_uv: 'gain.osc.gain.uv'
  };

  return kpiTranslations[kpi] != null ? kpiTranslations[kpi] : kpi;
};

export const getCounterInterpolations = (kpi) => {
  switch (kpi) {
    case 'deviceTwin.reported.antenna.direction.beamAzimuth':
    case 'deviceTwin.reported.antenna.direction.beamElevation':
    case 'deviceTwin.reported.VDL.Gain.value':
    case 'deviceTwin.reported.HDL.Gain.value':
    case 'deviceTwin.reported.VUL.Gain.value':
    case 'deviceTwin.reported.HUL.Gain.value':
      return 'step';
    case 'sysUpTime':
      return 'linear';
    default:
      return 'avg';
  }
};

export const coordinatePairToMapBoundArray = (x1, y1, x2, y2) => {
  return [
    [y1, x1],
    [y2, x1],
    [y2, x2],
    [y1, x2],
    [y1, x1]
  ];
};

export function azelToHeatmapIndex(az, el, config) {
  return [Math.round((el - config.el.min) / config.el.stepSize), Math.round((az - config.az.min) / config.az.stepSize)];
}

export const generateTestRasterInfo = () => {
  let min_az = -76;
  let max_az = 76;
  let step_az = 2;
  let min_el = -35;
  let max_el = 35;
  let step_el = 5;

  return { min_az: min_az, max_az: max_az, step_az: step_az, min_el: min_el, max_el: max_el, step_el: step_el };
};

// heatmap range depends on product type, not generation
// for now only n257 has defined range, and it is used for the rest of GA2 devices
export function getSuggestedHeatmapRange(version) {
  switch (version) {
    case 'ga2':
      return { min: -30, max: 20 };
    case 'ga1':
    default:
      return { min: -15, max: 20 };
  }
}

export function getDefaultHeatmapRange(version) {
  switch (version) {
    case 'ga2':
      return { min: -30, max: 0 }; // Updated the default value for heatmap
    case 'ga1':
    default:
      return { min: -15, max: 0 }; // Updated the default value for heatmap
  }
}

export function reformatHeatmapData(data, version) {
  switch (version) {
    case 'ga2':
      return reformatGA2HeatmapData(data);
    case 'ga1':
    default:
      return reformatGA1HeatmapData(data);
  }
}

export function reformatGA1HeatmapData(data = {}) {
  return createHeatmap(AzelRange, (azimuth, elevation) => getGA1HeatmapValue(data, azimuth, elevation));
}

function getGA1HeatmapValue(heatmap, azimuth, elevation) {
  const key = `${azimuth},${elevation}`;
  const value = heatmap[key];

  return Number.isNaN(value) ? null : value / 10;
}

export function reformatGA2HeatmapData(data = {}) {
  return createHeatmap(AzElRangeGA2, (azimuth, elevation) => getGA2HeatmapValue(data, azimuth, elevation));
}

function getGA2HeatmapValue(heatmap, azimuth, elevation) {
  const key = `${azimuth},${elevation}`;
  const value = heatmap?.[key];

  return value ?? null;
}

function createHeatmap(config, callback) {
  const azimuthValues = getRangeValues(config.az);
  const elevationValues = getRangeValues(config.el);

  return elevationValues.map((elevation) => azimuthValues.map((azimuth) => callback(azimuth, elevation)));
}

function getRangeValues({ min, max, stepSize }) {
  const length = Math.floor(Math.abs(max - min) / stepSize) + 1;

  return Array.from({ length }, (_, i) => min + i * stepSize);
}

export function reformatBeamRankData(data, heatmap, version) {
  switch (version) {
    case 'ga2':
      return reformatGA2BeamRankData(data, heatmap);
    case 'ga1':
    default:
      return reformatGA1BeamRankData(data, heatmap);
  }
}

function reformatGA1BeamRankData(data, heatmap = {}) {
  return mapBeamRankData(data, (value) => reformatGA1BeamRankValue(value, heatmap));
}

function reformatGA1BeamRankValue(value, heatmap) {
  const { beamAzimuth, beamElevation } = value;

  return {
    az: beamAzimuth,
    el: beamElevation,
    rssi: getGA1HeatmapValue(heatmap, beamAzimuth, beamElevation)
  };
}

function reformatGA2BeamRankData(data, heatmap) {
  if (Array.isArray(data)) {
    return data.map((beamrank) => reformatGA2BeamRankValue(beamrank));
  }

  return mapBeamRankData(data?.hpol, (value) => reformatGA2BeamRankValue(value, heatmap, 'v1'));
}

// sample ga2 beamrank data
// {
//   "azimuth": 45,
//   "elevation": 15,
//   "polarity": "vertical",
//   "power": -65.4,
//   "ssb-arfcn": 123456,
//   "5g-kpis": [
//     {
//       "pci": 1,
//       "issb": 2,
//       "ss-rsrp": -80,
//       "ss-rsrq": -10,
//       "ss-sinr": 20.5,
//       "rssi": -85,
//       "cell-barred": false
//     }
//   ]
// }
function reformatGA2BeamRankValue(beamrank, heatmap, version) {
  const { azimuth, elevation } = beamrank;

  if (version === 'v1') {
    return {
      az: azimuth,
      el: elevation,
      rssi: getGA2HeatmapValue(heatmap, azimuth, elevation)
    };
  }

  return {
    az: azimuth,
    el: elevation,
    pci: get(beamrank, '5g-kpis[0].pci', 'N/A'),
    ssbarfcn: get(beamrank, 'ssb-arfcn', 'N/A'),
    polarity: get(beamrank, 'polarity', 'N/A'),
    rssi: get(beamrank, '5g-kpis[0].rssi', 'N/A'),
    ssbIndex: get(beamrank, '5g-kpis[0].issb', 'N/A'),
    ssbRsrp: get(beamrank, '5g-kpis[0].ss-rsrp', 'N/A'),
    ssbRsrq: get(beamrank, '5g-kpis[0].ss-rsrq', 'N/A'),
    ssbSinr: get(beamrank, '5g-kpis[0].ss-sinr', 'N/A')
  };
}

function mapBeamRankData(data, callback) {
  const values = data != null ? Object.values(data) : [];

  return Array.from({ length: 3 }, (_, i) => {
    const value = values[i];
    const beamRankValue = value != null ? callback(value) : {};

    return {
      az: null,
      el: null,
      rssi: null,
      pci: null,
      rsrp: null,
      rsrq: null,
      ...beamRankValue
    };
  });
}

export function generateHeatmapColorFromVal(val, max, min) {
  let ratio = 1024 / (max - min);
  val = Math.round((val - min) * ratio);

  let r = 0;
  let g = 0;
  let b = 0;

  if (val < 256) {
    b = 255;
    g = val;
  } else if (val < 512) {
    val -= 256;
    g = 255;
    b = 255 - val;
  } else if (val < 768) {
    val -= 512;
    g = 255;
    r = val;
  } else if (val < 1024) {
    val -= 768;
    r = 255;
    g = 255 - val;
  } else if (val >= 1024) {
    r = 255; //the max value of a dynamically scaled heatmap
  } //should never get here
  else {
    // gray if no data
    r = 211;
    g = 211;
    b = 211;
  }

  return {
    red: r,
    green: g,
    blue: b
  };
}

export const isAzValid = (az, config) => {
  if (az == null) return false;

  return az === 361 || (config.az.min <= az && config.az.max >= az);
};

export const isElValid = (el, config) => {
  if (el == null) return false;

  return el === 361 || (config.el.min <= el && config.el.max >= el);
};

export const toggleDisplayNameForDevices = (device, displayType = deviceDisplayTypes.ID) => {
  if (!device) return '';
  let deviceDisplayName = device.id;
  switch (displayType) {
    case deviceDisplayTypes.ID:
      break;
    case deviceDisplayTypes.NAME:
      deviceDisplayName = device?.tags?.userLabel ? device.tags.userLabel : device.id;
      break;
    default:
      break;
  }

  return deviceDisplayName;
};

export const toggleDisplayNameForBundles = (bundle, displayType = deviceDisplayTypes.ID) => {
  if (!bundle) return '';
  let bundleDisplayName = bundle?.code ? bundle.code : 'POD_Unknown';
  switch (displayType) {
    case deviceDisplayTypes.ID:
      break;
    case deviceDisplayTypes.NAME:
      bundleDisplayName = bundle?.name ? bundle.name : 'Unnamed site';
      break;
    default:
      break;
  }

  return bundleDisplayName;
};

export const getKeyByValue = (object, value) => {
  return Object.keys(object).find((key) => object[key] === value);
};

export const reformatPeriodicCheckSwApiDayData = (data) => {
  let { recurrence, scheduleType, dayOfWeek, dayOfMonth } = data;
  let schedType = schedTypes[scheduleType];
  let newPeriodicSwCheckConfig = JSON.parse(JSON.stringify(defaultPeriodicSwCheckConfig));
  newPeriodicSwCheckConfig[schedType].recurrence = recurrence;

  Object.keys(newPeriodicSwCheckConfig).forEach((type) => {
    newPeriodicSwCheckConfig[type].selected = type === schedType;
  });
  switch (schedType) {
    case 'daily':
      break;
    case 'weekly':
      let dayKeys = [];
      if (dayOfWeek && Array.isArray(dayOfWeek)) {
        dayOfWeek.forEach((day) => {
          dayKeys.push(getKeyByValue(dayPrefixes, day));
        });
      } else if (dayOfWeek) {
        dayKeys.push(getKeyByValue(dayPrefixes, dayOfWeek));
      }
      Object.keys(newPeriodicSwCheckConfig[schedType].days).forEach((day) => {
        newPeriodicSwCheckConfig[schedType].days[day] = dayKeys.includes(day);
      });
      break;
    case 'monthly':
      if (dayOfMonth) {
        newPeriodicSwCheckConfig[schedType].occurrence.onDay.selected = true;
        newPeriodicSwCheckConfig[schedType].occurrence.onSequence.selected = false;
        newPeriodicSwCheckConfig[schedType].occurrence.onDay.day = dayOfMonth;
      }
      break;
    default:
      break;
  }

  return newPeriodicSwCheckConfig;
};

export const getUTCTime = (localHour = 0, localMinute = 0) => {
  const localDate = new Date();

  const utcDate = new Date(localDate.getFullYear(), localDate.getMonth(), localDate.getDate(), 0, 0);

  utcDate.setHours(localHour);

  utcDate.setMinutes(localMinute);

  return { hour: utcDate.getUTCHours(), minute: utcDate.getUTCMinutes() };
};

export const getLocalTime = (utcHour = 0, utcMinute = 0) => {
  const localDate = new Date();
  const utcDate = new Date(
    Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate(), utcHour, utcMinute)
  );

  return { hour: utcDate.getHours(), minute: utcDate.getMinutes() };
};

export const reformatPeriodicCheckSwApiTimeData = (data) => {
  let { hour, minute } = data;
  let localTime = getLocalTime(hour, minute);
  hour = localTime.hour;
  minute = localTime.minute;
  let hourStr = hour <= 9 ? `0${hour}` : `${hour}`;
  let minuteStr = minute === 0 ? '00' : '30';

  return hourStr + ':' + minuteStr;
};

export const rephraseScheduleText = (text) => {
  if (!text) return;
  let words = text.split(' ');
  let wordsLen = words.length;
  let hour = words[wordsLen - 1].split(':')[0];
  let minute = words[wordsLen - 1].split(':')[1];
  let localTime = getLocalTime(parseInt(hour), parseInt(minute));
  hour = localTime.hour;
  let localTimeStr = `${hour}:${minute}`;
  for (let i = 0; i < wordsLen; i++) {
    let foundKey = getKeyByValue(dayPrefixes, words[i]);
    if (foundKey) {
      words[i] = capitalizeFirstLetter(foundKey);
      break;
    }
  }
  words[wordsLen - 1] = localTimeStr;

  return words.join(' ');
};

export const areObjectsEqual = (a, b) => {
  if (a === b) return true;

  if (typeof a != 'object' || typeof b != 'object' || a == null || b == null) return false;

  let keysA = Object.keys(a),
    keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (let key of keysA) {
    if (!keysB.includes(key)) return false;

    if (typeof a[key] === 'function' || typeof b[key] === 'function') {
      if (a[key].toString() !== b[key].toString()) return false;
    } else {
      if (!areObjectsEqual(a[key], b[key])) return false;
    }
  }

  return true;
};

export const getDeviceFamilyType = (deviceType, productTypesList) => {
  if (!productTypesList || !deviceType) return 'unknown';

  let familyType;

  for (let family of productTypesList) {
    if (deviceType === family.name || deviceType === family.uiName) {
      familyType = family.name;
      break;
    }

    for (let member of family?.deviceMembers) {
      if (member.productType === deviceType || member.uiName === deviceType) {
        familyType = family.name;
        break;
      }
    }
  }

  return familyType;
};

export const getMatchingSwVersions = (device, allSwVersions, productTypesList, deviceType) => {
  let matchingVersions = [];
  const deviceFamilyType = getDeviceFamilyType(
    deviceType ? deviceType : device?.properties?.reported?.productType,
    productTypesList
  );

  if (!allSwVersions || allSwVersions.length === 0) return matchingVersions;

  Array.isArray(allSwVersions) &&
    allSwVersions.forEach((version) => {
      if (version.supported_device_types && version.supported_device_types.some((type) => type === deviceFamilyType)) {
        matchingVersions.push(version);
      }
    });

  return matchingVersions;
};

export const removeSpaces = (str) => str.replace(/\s/g, '');

export const hexToRGB = (hex, alpha = 0.3) => {
  let r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
  } else {
    return 'rgb(' + r + ', ' + g + ', ' + b + ')';
  }
};

export const SetImage = (strokeColor, fillColor, fillOpacity = 0.3) => (
  <svg width="24px" height="24px" fill={fillColor} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>polygon</title>
    <g strokeWidth="1" fill={fillColor} fillRule="evenodd" fillOpacity={fillOpacity}>
      <polygon
        stroke={strokeColor}
        strokeWidth="2"
        fill={fillColor}
        points="13.4 5 5 14.3333333 13.4 19 19 13.4"
      ></polygon>
    </g>
  </svg>
);

export const generateDefaultTabColumnsPreferenceReqBody = () => {
  return {
    category: USER_PREFERENCE_SETS.COLUMNS_SET,
    default: false,
    name: 'Tab Columns',
    state: {
      echoTab: DEFAULT_ECHO_TAB_COLUMNS,
      pivotTab: DEFAULT_PIVOT_TAB_COLUMNS,
      allDevicesTab: DEFAULT_ALL_DEVICES_TAB_COLUMNS
    }
  };
};

export const getSuggestedPolygonName = (list) => {
  const polygonNums = list
    .map((polygon) => {
      const currentName = polygon.properties.name.split('Polygon ');

      if (currentName[0] === '' && currentName[1] && currentName.length === 2) {
        return +currentName[1];
      }
      return null;
    })
    .filter((num) => num);

  if (polygonNums.length === 0) {
    return 'Polygon 1';
  }

  return `Polygon ${Math.max(...polygonNums) + 1}`;
};

export const getUserTag = (email) => {
  if (!email) return 'Unknown';

  // regex for email validation
  // eslint-disable-next-line no-useless-escape
  if (!email.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/)) return 'Unknown';

  return email.split('@')[0].substring(0, 4) + '_' + email.split('@')[1].substring(0, 1);
};

export const isEmailValid = (email) => emailRegex.test(email);

export function downloadJsonFile(json, filename) {
  downloadFile(new Blob([json], { type: 'application/json' }), { filename });
}

export function downloadCsvFile(csv, filename) {
  downloadFile(new Blob([csv], { type: 'text/csv' }), { filename });
}

export function downloadFile(blob, options) {
  const url = URL.createObjectURL(blob);

  download(url, options);
}

export function download(url, { filename } = {}) {
  const element = document.createElement('a');

  element.href = url;

  if (filename) {
    element.download = filename;
  }

  element.click();
}

export function toCSV(
  columns,
  rows,
  { rowSeparator = '\r\n', columnSeparator = ',', fallback = 'N/A', header = true } = {}
) {
  const getValue = (column, row) => {
    const value = column.accessor ? column.accessor(row) : row[column.name];

    return value ?? fallback;
  };

  const body = rows
    .map((row) => columns.map((column) => getValue(column, row)).join(columnSeparator))
    .join(rowSeparator);

  if (header) {
    return [
      columns.map((column) => column.displayName ?? column.name ?? column.uiName).join(columnSeparator),
      body
    ].join(rowSeparator);
  }

  return body;
}

export const getValueFromReference = (ref, property) => Math.floor(ref.current.getBoundingClientRect()[property]);
export function getDUAndSUsFromBundleMembers(members) {
  let du = null;
  let su1 = null;
  let su2 = null;
  for (let member of members) {
    if (distillProductType(member?.properties?.reported?.productType) === 'donor') {
      du = member;
    } else if (distillProductType(member?.properties?.reported?.productType) === 'service') {
      su1 === null ? (su1 = member) : (su2 = member);
    }
  }
  return { du, su1, su2 };
}

export const isValidInteger = (val) => Number.isInteger(val) && isFinite(val);

export const hasCMSwUpdatePermission = (permissions) => {
  if (!permissions || !Array.isArray(permissions)) return false;
  return permissions.includes('cm_software_update');
};

export const wait = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const createApiPolling = (pollCallback, checkCallback, options = {}) => {
  let { delay = 5000, timeoutMinute } = options;
  delay = process.env.NODE_ENV !== 'test' ? delay : 10;
  let timer = 0;
  async function poll(...args) {
    timer += delay;
    const output = await pollCallback(...args);
    if (timeoutMinute != null && timer === timeoutMinute * 60000) {
      throw Error('Timeout');
    } else if (!checkCallback(output)) {
      await wait(delay);
      return poll(...args);
    } else if (['error'].includes(output?.customStatus?.status)) {
      throw Error(output.customStatus?.message);
    }

    return output;
  }
  return poll;
};

export const normalizeISOString = (start, end) => {
  const startDate = moment(start).format('MM/DD/YYYY HH:mm');
  const endDate = moment(end).format('MM/DD/YYYY HH:mm');
  return startDate + ' - ' + endDate;
};

const production = process.env.NODE_ENV === 'production';

export const logger = ['debug', 'info', 'warning', 'error'].reduce((acc, severity) => {
  acc[severity] = production ? () => {} : (...args) => console[severity](...args);

  return acc;
}, {});

export const getErrorMessage = (errorCode) => {
  return ERROR_CODES?.[errorCode] || 'Something went wrong. Please try again later.';
};

export const createPermissionCheck = (requiredPermissions) => (userPermissions) =>
  userPermissions != null && requiredPermissions.every((permission) => userPermissions.includes(permission));

export function formatTimestampToLocal(timestamp) {
  if (timestamp === null) return 'N/A';

  const date = new Date(timestamp);
  return date.toLocaleString(); // This converts the date to a string in the local timezone
}

export function findLatestLastUpdatedValue(device, path) {
  if (!device || !path) return 'N/A';

  const metadata = device?.properties?.reported?.$metadata;
  if (!metadata) return 'N/A';

  const lastUpdatedValues = [];

  // Helper function to safely access nested properties based on the path
  const getNestedProperty = (obj, path) => {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  };

  // Check for $lastUpdated in DU
  const duLastUpdated = getNestedProperty(metadata.DU, `${path}.$lastUpdated`);
  if (duLastUpdated) {
    lastUpdatedValues.push(duLastUpdated);
  }

  // Iterate through SU objects in metadata
  for (const key in metadata) {
    if (key.startsWith('SU')) {
      const suLastUpdated = getNestedProperty(metadata[key], `${path}.$lastUpdated`);
      if (suLastUpdated) {
        lastUpdatedValues.push(suLastUpdated);
      }
    }
  }

  if (lastUpdatedValues.length === 0) return 'N/A';

  // Find the latest timestamp
  const latestDate = lastUpdatedValues.reduce((latest, timestamp) => {
    const date = new Date(timestamp);
    return !latest || date > latest ? date : latest;
  }, null);

  return latestDate ? formatTimestampToLocal(latestDate) : 'N/A';
}

export function getLatestRfPathTime(metadata, type = 'downlink') {
  if (!metadata) return 'N/A';

  console.log(metadata);
  let latestTime = null;

  // Check all RF paths (1-4)
  for (let i = 1; i <= 4; i++) {
    const rfPath = metadata[`rf-path-${i}`];
    if (!rfPath) continue;

    const normalOpInfo = rfPath?.['normal-op-info'];
    if (!normalOpInfo) continue;

    // Get the timestamp from the specific type (uplink/downlink)
    const typeData = normalOpInfo?.[type];
    if (typeData?.$lastUpdated) {
      const timestamp = new Date(typeData.$lastUpdated);
      if (!latestTime || timestamp > latestTime) {
        latestTime = timestamp;
      }
    }
  }

  return latestTime ? formatTimestampToLocal(latestTime) : 'N/A';
}

// Function to convert array to object with id as key
export function convertArrayToObject(array) {
  return array.reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
  }, {});
}

export function syncColumnStates(defaultState, databaseState) {
  const syncTab = (defaultTab, databaseTab) => {
    // Convert default tab array to object for easier syncing
    const defaultColumns = convertArrayToObject(defaultTab);

    // Convert database tab array to object
    let databaseColumns = convertArrayToObject(databaseTab);

    // Sync: Add new columns and remove deleted ones
    Object.keys(defaultColumns).forEach((id) => {
      if (!databaseColumns[id] || defaultColumns[id].uiName !== databaseColumns[id].uiName) {
        // Add new column from default state to database state
        databaseColumns[id] = defaultColumns[id];
      }
    });

    // Remove columns that exist in the database but not in the default state
    Object.keys(databaseColumns).forEach((id) => {
      if (!defaultColumns[id]) {
        delete databaseColumns[id];
      }
    });

    // Convert back to array
    return Object.values(databaseColumns);
  };

  // Sync each tab object
  return {
    allDevicesTab: syncTab(defaultState.allDevicesTab, databaseState.allDevicesTab),
    echoTab: syncTab(defaultState.echoTab, databaseState.echoTab),
    pivotTab: syncTab(defaultState.pivotTab, databaseState.pivotTab)
  };
}

export function hasColumnStateChanged(defaultState, databaseState) {
  const compareTabs = (defaultTab, databaseTab) => {
    const defaultColumns = convertArrayToObject(defaultTab);
    const databaseColumns = convertArrayToObject(databaseTab);

    // Check if the default state has new or removed columns
    for (const id in defaultColumns) {
      if (!databaseColumns[id] || defaultColumns[id].uiName !== databaseColumns[id].uiName) {
        return true; // Difference found
      }
    }
    return false; // No differences found
  };

  // Compare all three tabs
  return (
    compareTabs(defaultState.allDevicesTab, databaseState.allDevicesTab) ||
    compareTabs(defaultState.echoTab, databaseState.echoTab) ||
    compareTabs(defaultState.pivotTab, databaseState.pivotTab)
  );
}
